export const tr = {
    BYN: 'Belarus Rublesi',
    CHF: 'İsveç Frankı',
    EUR: 'Avro',
    KZT: 'Kazak Tengesi',
    RUB: 'Rus Rublesi',
    TRY: 'Türk Lirası',
    UAH: 'Ukrayna Hryvniası',
    USD: 'ABD Doları',
    UZS: 'Özbek Somu'
};
